import { ShowSnackBar, CloseSnackBar } from "event-definitions"
import { navigate } from "lib/routes/navigate"
import { uniqueId } from "library/database/split-id.mjs"
import { RefiningTypes } from "library/server-event-definitions/shared-events.mjs"
import { ProcessingSnackbarContent } from "routes/asset-register/plugins/asset-mapping/plugins/progress-card/snackbar/processing-snackbar-content"

RefiningTypes.before.handleOnce(handleRefiningTypesChange)

export function showProcessingSnackbar(registerId, { registerName }) {
    const snackbarKey = `processing-${uniqueId(registerId)}`

    ShowSnackBar.raise(
        <ProcessingSnackbarContent
            registerId={registerId}
            registerName={registerName}
            onViewProgress={navigateToProgress(registerId)}
        />,
        {
            variant: "info",
            persist: true,
            preventDuplicate: true,
            key: snackbarKey,
        }
    )
}

export function dismissProcessingSnackbar(registerId) {
    if (!registerId) return

    CloseSnackBar.raise(`processing-${uniqueId(registerId)}`)
}

function handleRefiningTypesChange(registerId, isBusy) {
    if (!isBusy) {
        dismissProcessingSnackbar(registerId)
    }
}

function navigateToProgress(registerId) {
    return function viewProgress() {
        dismissProcessingSnackbar(registerId)
        navigate(`/app/assets/${encodeURIComponent(uniqueId(registerId))}?asset-tabsTab=types`)
    }
}
